export class LiquiditySource {
  source_sid = 0;
  name: string = null;
  mnemonic: string = null;
  type: 'Primary' | 'Secondary' | 'Tertiary' = null;
  calculate_group: number = null;
  draw_order: number = null;
  balance_sheet_account_mnemonic: string = null;
  balance_sheet_add_factor: number = null;

  constructor(obj: Object) {
    for (const prop in obj) {
      if (this.hasOwnProperty(prop)) {
        this[prop] = obj[prop];
      }
    }
  }
}

export class ArchivedLiquiditySource {
  BalanceSheetAccountMnemonic: string;
  BalanceSheetAddFactor: number;
  Calculate_Group: number;
  Draw_Order: number;
  Mnemonic: string;
  Name: string;
  PeriodEquations: any[];
  Source_SID: number;
  Type: 'Primary' | 'Secondary' | 'Tertiary';
}
